import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { combineAddress } from "../../../../../app/utils";
import { BackButton, Button, LineSeperator } from "../../../../../components/RegularComponents";
import { editAdditionalBranchField } from "../../../../../redux/slice/additionalApplicationsSlice";
import { saveBusinessLicenceApplicationData } from "../../../../../redux/slice/businessLicenceApplicationSlice";
import "../../BLTInformation.styles.scss"
import { InformationDetailPanelSection } from "../../InformationDetailPanelSection";

export const BranchDetails = (props) => {
    const { branch, setBranch, isArchiveApplication, applicationType } = props
    const handleGoBack = () => {
        setBranch()
    }

    return (
        <div className="licence-application-details-panel">
            <BackButton onClick={handleGoBack} />
            <div className="licence-application-details-panel">
                <DetailSection 
                    data={branch} 
                    isArchiveApplication={isArchiveApplication} 
                    applicationType={applicationType}
                />
            </div>

        </div>
    )
}

const DetailSection = ({ data, isArchiveApplication, applicationType }) => {

    const [sectionToEdit,setSectionToEdit] = useState({
        ...data
    });
    const [currentEditSetionKey, setCurrentEditSectionKey] = useState(null)

    const dispatch = useDispatch();
    
    const inputEditForm = (sectionKey) => {
        const value = sectionToEdit[sectionKey]
        
        const onChange = (changedValue) => {
            setSectionToEdit(Object.defineProperty({...sectionToEdit}, 
                sectionKey, 
                {value : changedValue, writable: true, enumerable: true})
            )
        }

        return (
            <fieldset className={"ns-fieldset fw-35"} id="edit-form">
                <div className="ns-fieldset row bottomMarginNormal">
                    <input
                        className="ns-input"
                        type="text"
                        id="edit-form"
                        name="edit-form"
                        value={value}
                        onChange={(e) => {
                            onChange(e.target.value)
                        }}
                    />
                </div>
            </fieldset>
        )
    }

    const editAddressForm = (sectionKey, businessAddress) => {
        const onChange = (property, value) => {
            
            let updatedAddress = {...sectionToEdit[sectionKey]}
            Object.defineProperty(updatedAddress, property, {value : value, writable: true, enumerable: true})

            let updatedSectionToEdit = {...sectionToEdit}
            Object.defineProperty(updatedSectionToEdit, sectionKey, {
                value : updatedAddress, 
                writable: true, 
                enumerable: true
            })
            setSectionToEdit(updatedSectionToEdit)
        }

        return (
            <fieldset className={"ns-fieldset"} id="business-address-edit-form">
                <div className="ns-fieldset row bottomMarginNormal">
                    <label
                        className="ns-label"
                        autoComplete="street-address"
                        htmlFor="businessAddressStreetEdit">
                            Street Address
                    </label>
                    <textarea
                        className="fw-25 ns-input"
                        type="text"
                        id="businessAddressStreetEdit"
                        rows={4} 
                        cols={60}
                        name="city"
                        onChange={e => onChange("street", e.target.value)}>
                            {businessAddress["street"]}
                    </textarea>
                </div>
                <div className="ns-fieldset row bottomMarginNormal">
                    <label for="businessAddressCityEdit">City</label>
                    <input
                        className="fw-25 ns-input"
                        type="text"
                        id="businessAddressCityEdit"
                        name="city"
                        value={businessAddress["city"]}
                        onChange={e => onChange("city", e.target.value)} />
                </div>
                {/* <div className="ns-fieldset row bottomMarginNormal">
                    <label
                        id={"mra-province-select-label"}
                        className="ns-label"
                        htmlFor={"mra-province-select-input"}
                    >
                        Province
                    </label>
                    <div className="select fw-25 inlineDisplay">
                        <select
                        style={{ width: "25em" }}
                        id={"mra-province-select-input"}
                        name={"mra-province-select-input"}
                        value={businessAddress["province"] ?? ""}
                        onChange={e => onChange("province", e.target.value)}
                        >
                        {provinceOptionElements}
                        </select>
                    </div>
                </div> */}
                <div className="ns-fieldset row">
                    <label htmlFor="businessAddressPINEdit">Postal Code</label>
                    <input
                        type="text"
                        className="fw-25"
                        id="businessAddressPINEdit"
                        name="pin"
                        value={businessAddress["postalCode"]}
                        onChange={e => onChange("postalCode", e.target.value)} 
                    />
                </div>
            </fieldset>
        )
    }

    const contactNameJSX = useCallback((sectionKey) => {

        //const sectionKey = "responsibleAgent"
        if(currentEditSetionKey === sectionKey) {
            const nameObject = sectionToEdit[sectionKey] ?? {firstName : "", phoneNumber : "", emailAddress : ""}

            const onChange = (property, value) => {
                let updatedObj = {...sectionToEdit[sectionKey]}
                Object.defineProperty(updatedObj, property, {value : value, writable: true, enumerable: true})

                let updatedSectionToEdit = {...sectionToEdit}
                Object.defineProperty(updatedSectionToEdit, sectionKey, {
                    value : updatedObj, 
                    writable: true, 
                    enumerable: true
                })
                setSectionToEdit(updatedSectionToEdit)
            }

            return (
                <fieldset className={"ns-fieldset"} id="name-edit-form">
                    <div className="ns-fieldset row bottomMarginNormal">
                        <label
                            className="ns-label"
                            autoComplete="first-name"
                            htmlFor="businessFirstNameEdit">
                                Name
                        </label>
                        <input
                            className="fw-25 ns-input"
                            type="text"
                            id="firstNameEdit"
                            name="firstNameEdit"
                            value={nameObject["firstName"]}
                            onChange={(e) => {
                                onChange("firstName", e.target.value)                
                            }} />
                    </div>
                    <div className="ns-fieldset row bottomMarginNormal">
                        <label
                            className="ns-label"
                            autoComplete="phone-number"
                            htmlFor="phoneNumberEdit">
                                Phone number
                        </label>
                        <input
                            className="fw-25 ns-input"
                            type="text"
                            id="phoneNumberEdit"
                            name="phoneNumberEdit"
                            value={nameObject["phoneNumber"]}
                            onChange={(e) => {
                                onChange("phoneNumber", e.target.value)                
                            }} />
                    </div>
                    <div className="ns-fieldset row bottomMarginNormal">
                        <label
                            className="ns-label"
                            autoComplete="email-address"
                            htmlFor="emailAddressEdit">
                                Email
                        </label>
                        <input
                            className="fw-25 ns-input"
                            type="text"
                            id="emailAddressEdit"
                            name="emailAddressEdit"
                            value={nameObject["emailAddress"]}
                            onChange={(e) => {
                                onChange("emailAddress", e.target.value)                
                            }} />
                    </div>
                </fieldset>
            )
        } else {
            const obj = sectionToEdit[sectionKey] ?? {firstName : "", phoneNumber : "", emailAddress : ""}

            return (
            <div style={{display: "flex", flexDirection: "column"}}>
                <div>
                    <b>Name</b>
                    <span style={{marginLeft : "10px"}}>
                        {`${obj.firstName ?? ""}`}
                    </span>
                </div>
                <div>
                    <b>Phone number</b>
                    <span style={{marginLeft : "10px"}}>
                        {obj.phoneNumber ?? ""}
                    </span>
                </div>
                <div>
                    <b>Email</b>
                    <span style={{marginLeft : "10px"}}>
                        {obj.emailAddress ?? ""}
                    </span>
                </div>
            </div>)
        }
    }, [sectionToEdit, currentEditSetionKey])

    const handleSave = (section) => { 
        
        dispatch(editAdditionalBranchField({
            branchApplicationId : data.branchApplicationId, 
            branchObject : Object.defineProperty(
                {}, 
                section, 
                {
                    value : sectionToEdit[section], 
                    writable: true, 
                    enumerable: true
                })})
        )

        dispatch(saveBusinessLicenceApplicationData(applicationType))
        .then(() => {
            setCurrentEditSectionKey(null)
        })
    }

    const handleClick = (section) => {
        setCurrentEditSectionKey(section)
    }

    return (
        <>
        {/* Branch Name */}
        <InformationDetailPanelSection 
            header={"Branch name"} 
            value1={data.branchName}
            value={(currentEditSetionKey === "branchName") ? 
                        inputEditForm("branchName",sectionToEdit["branchName"]) : 
                        sectionToEdit["branchName"] ?? data?.branchName} 
        >
            {((currentEditSetionKey === "branchName") ?
                <Button 
                    buttonType="regular_success" 
                    text={"Save"} 
                    disabled={isArchiveApplication}
                    onClick={() => handleSave("branchName")} 
                /> : 
                <Button 
                    buttonType="regular_primary" 
                    text={"Edit"} 
                    disabled={isArchiveApplication}
                    onClick={() => handleClick("branchName")} 
                />)
            }
        </InformationDetailPanelSection>
        <LineSeperator />
        {/* Branch civic address */}
        <InformationDetailPanelSection 
            header={"Branch civic address"} 
            value1={combineAddress(data.address)} 
            value={("address" === currentEditSetionKey) ? 
                    editAddressForm("address",sectionToEdit["address"]) :
                    combineAddress(sectionToEdit["address"])
                }
        >
            {("address" === currentEditSetionKey) ?
                <Button 
                    buttonType="regular_success" 
                    text={"Save"} 
                    disabled={isArchiveApplication}
                    onClick={() => handleSave("address")} 
                /> : 
                    <Button 
                    buttonType="regular_primary" 
                    text={"Edit"} 
                    disabled={isArchiveApplication}
                    onClick={() => handleClick("address")} 
                />}
        </InformationDetailPanelSection>

        <LineSeperator />

        {/* Responsible agent */}
        <InformationDetailPanelSection 
            header = "Responsible agent"
            value = {contactNameJSX("manager")} 
        >
            {("manager" === currentEditSetionKey) ? 
            <Button 
                buttonType="regular_success" 
                text={"Save"} 
                disabled={isArchiveApplication}
                onClick={() => handleSave("manager")} 
            /> : 
            <Button 
                buttonType="regular_primary" 
                text={"Edit"} 
                disabled={isArchiveApplication}
                onClick={() => handleClick("manager")} 
            />
        }
        </InformationDetailPanelSection>
        </>
    )
}